export const selectHasCartItems = state => {
  const cartItems = state.cart?.items ?? [];
  return cartItems.length >= 1;
};
